type FeatureTest = {
  name: string;
};

type FeatureTestVariant = {
  name: string;
};

type FeatureTestUserVariant = {
  featureTest: FeatureTest;
  featureTestVariant: FeatureTestVariant;
};

type JSONFeatureTest = {
  name: string;
};

type JSONFeatureTestVariant = {
  name: string;
};

type JSONFeatureTestUserVariant = {
  feature_test: JSONFeatureTest;
  feature_test_variant: JSONFeatureTestVariant;
  id: number;
  object_created: string;
  object_updated: string;
};

function featureTestUserVariantFromJSON(
  variant: JSONFeatureTestUserVariant,
): FeatureTestUserVariant {
  return {
    featureTest: {
      name: variant.feature_test.name,
    },
    featureTestVariant: {
      name: variant.feature_test_variant.name,
    },
  };
}

function featureTestVariantFromJSON(variant: JSONFeatureTestVariant): FeatureTestVariant {
  return {
    name: variant.name,
  };
}

export default FeatureTest;

export {
  FeatureTestVariant,
  FeatureTestUserVariant,
  featureTestUserVariantFromJSON,
  featureTestVariantFromJSON,
  JSONFeatureTestUserVariant,
  JSONFeatureTestVariant,
};
